/* eslint-disable */
import pingpp from 'pingpp-js';
import qs from 'qs';
import { onIosBack } from '@/lib/event/utils';
const isWechat = (function() {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return /MicroMessenger/i.test(userAgent);
})();

export function executeCharge(charge: any) {
  return new Promise((rs, rj) => {
    // 处理页面返回后，缓存内容
    const removeEvent = onIosBack(rj);
    pingpp.createPayment(charge, (result: string, err: any) => {
      removeEvent();
      if (result === 'success') {
        console.log('创建支付成功');
        rs(result);
      } else {
        // ping++ 真实支付时若取消支付，result为'cancel'

        rj({ result, err });
      }
    });
  });
}
export enum PayChannel {
  WXAuto = 'wx_auto', // 根据环境来自动选择
  WXPub = 'wx_pub', // 微信h5 网页内唤起支付
  WXWap = 'wx_wap', // h5 微信支付
  AliPayQr = 'alipay_wap', // 支付宝链接
  UpacpWap = 'upacp_wap',
  huabei = 'huabei',
}
export function getChannel(type: PayChannel) {
  let payType = type;
  if (type === PayChannel.WXAuto) {
    if (isWechat) {
      payType = PayChannel.WXPub;
    } else {
      payType = PayChannel.WXWap;
    }
  }
  return payType;
}
export function getAlipayProxyUrl(url: string, query = {}) {
  const base =
    window.location.origin +
    window.location.pathname.replace(/\d+$/, '') +
    'pay/proxy';
  const queryString = qs.stringify(query);
  return base + `?alipayurl=${url}${queryString ? '&' + queryString : ''}`;
}
